import React from "react";
// import PropTypes from 'prop-types'
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import {
  primaryColor,
  secondaryColor,
  tercaryColor,
  bodyColor,
  buttonBgColor,
  bodyAltColor,
} from "helpers/colors";
export default class Theme extends React.Component {
  render() {
    const { children } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: {
          main: primaryColor,
          secondary: "#ff0000",
          dark: primaryColor,
          contrastText: "#fff",
        },
        secondary: {
          // main: primaryColor,
          main: primaryColor,
          light: "#fff",
          dark: "#fff",
          contrastText: "#fff",
        },
        text: {
          primary: bodyColor,
          // disabled: bodyColor,
          secondary: "#fff",
        },
        action: {
          disabled: "#ccc",
        },
        background: {
          default: "#fff",
        },
        // action: {
        //   active: '#ff0000',
        //   selected: '#ff0000',
        //   hover: '#ff0000',
        // }
      },
      typography: {
        fontFamily: "Montserrat, Helvetica, Arial, sans-serif",
        fontSize: 12,
        useNextVariants: true,
        h1: {
          padding: "10px 30px",
          fontSize: "20px",
          color: "#fff",
          fontWeight: "normal",
          backgroundColor: "transparent",
          color: "#004b7f",
          fontSize: "3rem",
          textTransform: "uppercase",
        },
        h2: {
          color: primaryColor,
          letterSpacing: "0.39px",
          fontSize: "26px",
        },
        h3: {
          color: secondaryColor,
          fontSize: "30px",
          fontWeight: "bold",
          // lineHeight: "47px",
          lineHeight: "32px",
        },
        h4: {
          color: primaryColor,
          fontSize: "24px",
          // lineHeight: "40px",
          lineHeight: "28px",
          textAlign: "center",
        },
        h5: {
          fontSize: "1.6rem",
          lineHeight: "1.43",
          color: bodyColor,
        },
        h6: {
          color: "#666",
          textAlign: "center",
        },
        body1: {
          '& a': {
            color: 'inherit',
          }
        },
        body2: {
          color: bodyAltColor,
          fontSize: "14px",
          fontWeight: 500,
          letterSpacing: "0.5px",
          lineHeight: "29px",
        },
        subtitle1: {
          letterSpacing: "2px",
          fontSize: "14px",
        },
        caption: {
          fontSize: "12px",
          letterSpacing: "0.43px",
          fontStyle: "italic",
        },
        subtitle2: {
          textTransform: "uppercase",
          color: "#009EE3",
          letterSpacing: "1.17px",
          fontSize: "14px",
        },
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920,
        },
      },
      overrides: {
        MuiButton: {
          outlinedPrimary: {
            color: "#fff",
          },
          outlinedSecondary: {
            color: "#fff",
          },
          root: {
            // color: primaryColor, // Some CSS
            // backgroundColor: '#d2d2d2'
            color: "#fff", // Some CSS
            backgroundColor: buttonBgColor,
            border: "1px transparent solid",
            padding: "8px 20px",
            boxShadow:
              "0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)",
            "& .MuiButton-label": {
              padding: "3px 15px",
            },
            // '&.outlinedPrimary': {
            //   color: '#fff',
            // },
            // '&.outlinedSecondary': {
            //   color: '#fff',
            // },
            "&:hover": {
              backgroundColor: "#fff",
              border: "1px " + bodyColor + " solid",
              color: bodyColor,
            },
            "&.MuiButton-sizeLarge": {
              // padding: "8px 20px",
              padding: "8px 20px",
              // paddingLeft: 50,
              // paddingRight: 50
            },
            // '&.MuiButton-testSizeLarge': {
            //   paddingLeft: 50,
            //   paddingRight: 50
            // },
            "&.MuiButton-textSecondary": {
              backgroundColor: "#fff",
              color: primaryColor,
              "&:hover": {
                backgroundColor: tercaryColor,
                color: "#fff",
              },
            },
          },
        },
        "MuiButton-textSecondary": {},
        MuiFormHelperText: {
          root: {
            color: "#666",
          },
        },
        "MuiStepper-root": {
          padding: 0,
        },
        MuiStep: {
          root: {
            "& > .MuiStepConnector-root": {
              display: "none",
            },
          },
        },
        MuiInputLabel: {
          outlined: {
            color: 'inherit'
          }
        }
        //             fontSize: '24px',
        //             width: 34,
        //             height: 34,
        //             marginTop: '-7px',
        //             color: 'green',
        //             border: '2px '+secondaryColor+' solid',
        //             opacity: .3,
        //             '& .MuiStepIcon-text': {
        //               color: 'blue'
        //             },
        //             '& > circle': {
        //               fill: '#fff'
        //             },
        //             '& > text': {
        //               fill: primaryColor
        //             },
        //             '&.MuiStepIcon-active': {
        //               marginTop: '-13px',
        // backgroundColor: '#fff',
        //               width: 50,
        //               height: 50,
        //               opacity: 1
        //             }
        //           }
        //         }
        // // MuiInput: {
        // //   root: {
        // //     color: primaryColor
        // //   },
        // //   outlined: {
        // //     borderRadius: '30px'
        // //   }
        // // },
        // MuiOutlinedInput: {
        //   input: {
        //     paddingLeft: 15,
        //     paddingRight: 15
        //     // textAlign: 'center'
        //   }
        // },
        // MuiPrivateNotchedOutline: {
        //   root: {
        //     borderRadius: '30px',
        //     overflow: 'hidden',
        //     textAlign: 'center'
        //   }
        // },
        // MuiPaper: {
        //   rounded: {
        //     borderRadius: '16px'
        //   }
        // }
      },
    });
    // console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx